import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {getAccountDetails, getAdmin, getUserPermission, getAccountAutoPayStatus} from '../../../../../../selectors/index';
import {getMyAutoPayInfo, emptyMyAutoPayInfo} from "../../../../../../actions/accountDetailsActions/accountDetails.actions";
import { getBillingBadjes, emptyBillingBadjes } from '../../../../../../actions/accountDetailsActions/billing.actions';
import { showModal } from '../../../../../../actions/modal.actions';
import {getPrimaryContacts} from "../../../../../../actions/admin.actions";
import Balances from './Balances';
import Adjustments from './Adjustments';
import Invoices from './Invoices';
import Payments from './Payments';
import InstallmentPlan from './InstallmentPlans';
import Discounts from './Discounts';
import ReccuringCredits from './ReccuringCredits';
import TaxExemptions from './TaxExemptions';
import PaymentPromises from './PaymentPromises';
import {
	emptyAccountTypeDistributionMethods,
	getAccountDistributionMethod,
	getAccountTypeDistributionMethods
} from "../../../../../../actions/admin.actions";
import {statusColor} from "../../../../../../utils/ui";
import isEmpty from "../../../../../../utils/helpers";
import StatusHistory from "./StatusHistory";
import PaymentMethods from "src/containers/AccountDetails/Panels/LeftPanel/Tabs/Billing/PaymentMethods";
import {getCurrentPaymentProviderSupportsPaymentMethodStorage} from "src/actions/paymentProvider.actions";
import '../../../../../../customStyles.css'
import { getAccountAutoPay } from "src/actions/autoPay.actions"


export class Billing extends Component {

	state = {
		collapsedMenuItem: 'balances',
		isPaperlessActive: false,
		myAutoPayInfoLoaded: false,
		myDistributionMethodsLoaded: false,
		customerPortalStatusLoaded: false,
		customerPortalStatus: '',
		fetchAttempts: 0,
	};

	componentDidMount() {
		const { accountInfo, history, getCurrentPaymentProviderSupportsPaymentMethodStorage } = this.props;
		// this.fetchBalanceInterval = setInterval(this.fetchUpdatedBalanceWithCheck, 3000);
		this.props.getBillingBadjes(accountInfo.id);
		this.checkIsPaperlessActive();
		this.props.getAccountTypeDistributionMethods(accountInfo.accountType.name).then(response => {
			if (response.status === 200) {
				this.setState({myDistributionMethodsLoaded: true})
			}
		});
		this.checkIsAutoPayActive();
		this.loadCustomerPortalStatus();

		if (history.location.state && !isEmpty(history.location.state.billingTabActiveItem)) {
			this.setCollapsedMenuItem(history.location.state.billingTabActiveItem);
			history.replace({state: undefined});
		}
		getCurrentPaymentProviderSupportsPaymentMethodStorage()
	}

	componentWillUnmount() {
		this.props.emptyBillingBadjes();
		this.props.emptyAccountTypeDistributionMethods();
		this.props.emptyMyAutoPayInfo();
	}

	checkIfPermissionsPresent = (payNowPermissions) => {
		let isPresent = payNowPermissions.some((element) => Object.values(element).includes(true))
		return isPresent
	}

	checkIsPaperlessActive = () => {
		this.props.getAccountDistributionMethod(this.props.accountInfo.id).then(response => {

			this.setState({
				isPaperlessActive: response.data.distributionMethods[0]
					? response.data.distributionMethods[0].name !== 'paper'
					: false
			});
		});
	}

	checkIsAutoPayActive = () => {
		this.setState({myAutoPayInfoLoaded: false});
		this.props.getAccountAutoPay(this.props.accountInfo.id).then(res => {
			this.props.getMyAutoPayInfo(this.props.accountInfo.id).then(response =>
				this.setState({myAutoPayInfoLoaded: true})
			);
		})


	}

	setCollapsedMenuItem = (menuItem) => {
		this.setState({
			collapsedMenuItem: this.state.collapsedMenuItem === menuItem ? '' : menuItem
		});
	};

	setCustomerPortalColor = (userAccess) => {

		// Secondary - gray
		let color = 0;

		if (!isEmpty(userAccess)) {
			let customerPortalActive = userAccess.isActive;
			let loginAttempts = userAccess.invalidLoginAttempts;

			if (customerPortalActive) {
				// Success - green
				color = 4;
			}
			else {
				if (loginAttempts > 1) {
					// Danger - red
					color = 1;
				}
				else {
					// Warning - yellow
					color = 3;
				}
			}
		}

		this.setState({
			customerPortalStatus: color,
			customerPortalStatusLoaded: true,
		})
	}

// 	fetchUpdatedBalanceWithCheck = () => {
// 		const { accountInfo, getMyAmounts, myAmounts } = this.props;
// 		const oldAccountbalance = this.props.accountBalance;
// 
// 		if (this.state.fetchAttempts < 7) {
// 			this.props.getAccountBalance(accountInfo.id).then(() => {
// 				const newBalance = this.props.accountBalance;
// 				if (newBalance !== oldAccountbalance) {
// 					this.setState({ accountBalance: newBalance });
// 					clearInterval(this.fetchBalanceInterval);
// 					this.setState({ fetchAttempts: 0 });
// 				} else {
// 					this.setState(prevState => ({
// 						fetchAttempts: prevState.fetchAttempts + 1
// 					}));
// 				}
// 			}).catch(error => {
// 
// 				this.setState(prevState => ({
// 					fetchAttempts: prevState.fetchAttempts + 1
// 				}));
// 			});
// 		} else {
// 			clearInterval(this.fetchBalanceInterval);
// 			this.setState({fetchAttempts: 0})
// 
// 		}
// 	}
// 
	loadCustomerPortalStatus = () => {
		this.setState({
			customerPortalStatus: 0,
			customerPortalStatusLoaded: false,
		});

		this.props.getPrimaryContacts(this.props.accountInfo.id).then((response) => {
			this.setCustomerPortalColor(response.data.contacts[0].userAccess);
		});
	}

	render() {
		const { collapsedMenuItem, isPaperlessActive, myAutoPayInfoLoaded, myDistributionMethodsLoaded,
			customerPortalStatusLoaded, customerPortalStatus } = this.state;
		const { accountInfo, billingBadjesData, myDistributionMethods,
			changeTabHandler, primaryContacts, canViewOCC,
			canViewInvoices, canViewPayments, canEditAutopay, canEditPaperless,
			canEditCustomerPortalAccess, canViewBalances, canViewInstallmentPlans,
			canViewRecurringCredits, canViewDiscounts, canViewPaymentPromises,
			canViewTaxExemptions, canViewHistorical, payNowPermissions, canManagePaymentMethods, autoPayWarning, autoPayStatus} = this.props;



		return (
			<div className="tab-pane card-body fade active show">
				<div className="tab-pane-toolbar">
					<div className="btn-toolbar mr-auto">

						<button
							className={"btn btn-icon" + (isPaperlessActive ? " btn-icon-success" : "")}
							onClick={() => this.props.showModal('PAPERLESS_MODAL', {
								myDistributionMethods,
								onCloseCallback: () => this.checkIsPaperlessActive()
							}
							)}
							title="Paperless"
							type="button"
							disabled={!myDistributionMethodsLoaded || !canEditPaperless}
							style={!myDistributionMethodsLoaded ? {cursor: "progress"} :
								isPaperlessActive ? {color: "#95ba55"} : {}}
						>
							{myDistributionMethodsLoaded
							?
							<i className="fab fa-fw fa-envira" />
							:
							<i className="fas fa-fw fa-spin fa-spinner"/>
							}
						</button>

						<button className={"btn btn-icon" +
							((this.props.myAutoPayInfo && this.props.myAutoPayInfo.length !== 0)
								? " btn-icon-success" : ""
							)}
										onClick={() => {
											this.props.emptyMyAutoPayInfo();
											this.props.showModal('AUTOPAY_MODAL', {
												onCloseCallback: () => {this.checkIsAutoPayActive()},
												autoPayWarning: autoPayWarning,
												autoPayOn: autoPayStatus,
											})
										}}
							title="AutoPay"
							type="button"
							disabled={!myAutoPayInfoLoaded || !canEditAutopay}
							style={!myAutoPayInfoLoaded ? {cursor: "progress"} :
								!isEmpty(this.props.myAutoPayInfo) || autoPayWarning ? {color: "#95ba55"} : {}}
						>
							{myAutoPayInfoLoaded
							?
								<span className="fa-stack fa-1x ">
            <i className="fas fa-fw fa-sync-alt fa-stack-2x" />
            <i className="fas fa-fw fa-dollar-sign fa-stack-1x" />
									{autoPayWarning && <span className="fas fa-exclamation-triangle warning-icon "></span>}
							</span>
							:
							<i className="fas fa-fw fa-spin fa-spinner"/>
							}
						</button>

						<button
							className={`btn btn-customer-portal btn-icon btn-icon-${statusColor(this.state.customerPortalStatus)}`}
							onClick={() => {
								this.props.showModal('CUSTOMER_PORTAL_MODAL', {
									primaryContact: primaryContacts[0],
									onCloseCallback: () => {this.loadCustomerPortalStatus()}
								})
							}}
							title="Customer Portal"
							type="button"
							disabled={!customerPortalStatusLoaded || !canEditCustomerPortalAccess}
							style={!customerPortalStatusLoaded ? {cursor: "progress"} :
								customerPortalStatus ? {color: "#95ba55"} :	{}}
						>
							{customerPortalStatusLoaded
							?
							<span className="fa-stack">
								<i className="fas fa-user fa-stack-2x" />
								<i className="fas fa-desktop fa-stack-1x" />
							</span>
							:
							<i className="fas fa-fw fa-spin fa-spinner"/>
							}
						</button>

					</div>

					{this.checkIfPermissionsPresent(payNowPermissions) &&
						<button
							onClick={() => this.props.showModal('PAY_NOW_MODAL', {onCloseCallback: () => changeTabHandler('billing')})}
							type="button"
							className="btn btn-xl btn-outline-success"
						>
							<i className="fas fa-money-bill-alt" /> Pay Now
						</button>
					}

				</div>
				<div className="accordion">
					{canViewBalances &&
						<div className="container-accordion-content container-client-balance">
							<h3
								onClick={() => this.setCollapsedMenuItem('balances')}
								className={collapsedMenuItem === 'balances' ? '' : 'collapsed'}
								data-toggle="collapse"
							>
								Balances
							</h3>
							<div className={'collapse-with-table collapse' + (collapsedMenuItem === 'balances' ? ' show': '')}>
								{collapsedMenuItem === 'balances' && <Balances accountInfo={accountInfo} />}
							</div>
						</div>
					}
					{canViewOCC &&
						<div className="container-accordion-content container-client-adjustemnts">
							<h3
								onClick={() => this.setCollapsedMenuItem('adjustments')}
								className={collapsedMenuItem === 'adjustments' ? '' : 'collapsed'}
								data-toggle="collapse"
							>
								Other Charges and Credits
								{billingBadjesData.pendingAdjustments > 0 && (
									<span className="float-right badge badge-warning">
									{billingBadjesData.pendingAdjustments} Pending
								</span>
								)}
							</h3>
							<div className={'collapse-with-table collapse' + (collapsedMenuItem === 'adjustments' ? ' show': '')}>
								{collapsedMenuItem === 'adjustments' && <Adjustments accountInfo={accountInfo} />}
							</div>
						</div>
					}
					{canViewInvoices &&
						<div className="container-accordion-content container-client-adjustemnts">
							<h3
								onClick={() => this.setCollapsedMenuItem('invoices')}
								className={collapsedMenuItem === 'invoices' ? '' : 'collapsed'}
								data-toggle="collapse"
							>
								Invoices
								{billingBadjesData.unpaidInvoices > 0 && (
									<span className="float-right badge badge-warning">
									{billingBadjesData.unpaidInvoices} Unpaid
								</span>
								)}
							</h3>
							<div className={'collapse-with-table collapse' + (collapsedMenuItem === 'invoices' ? ' show': '')}>
								{collapsedMenuItem === 'invoices' && <Invoices accountInfo={accountInfo} />}
							</div>
						</div>
					}
					{canViewInstallmentPlans &&
						<div className="container-accordion-content container-client-adjustemnts">
							<h3
								onClick={() => this.setCollapsedMenuItem('installmentplans')}
								className={collapsedMenuItem === 'installmentplans' ? '' : 'collapsed'}
								data-toggle="collapse"
							>
								Installment Plans
								{billingBadjesData.activeInstallmentPlans > 0 && (
									<span className="float-right badge badge-warning">
									{billingBadjesData.activeInstallmentPlans} Pending
								</span>
								)}
							</h3>
							<div className={'collapse-with-table collapse' + (collapsedMenuItem === 'installmentplans' ? ' show': '')}>
								{collapsedMenuItem === 'installmentplans' && <InstallmentPlan accountInfo={accountInfo} />}
							</div>
						</div>
					}
					{canManagePaymentMethods &&
						<div className="container-accordion-content container-client-adjustemnts">
							<div style={{display:'flex', alignItems:'center', borderBottom:'1px solid rgb(222, 226, 230)'}}>
								<h3
									onClick={() => this.setCollapsedMenuItem('paymentMethods')}
									className={collapsedMenuItem === 'paymentMethods' ? '' : 'collapsed'}
									data-toggle="collapse"
									style={{borderBottom:'none'}}
								>
									Payment Methods
								</h3>
							</div>
							<div className={'collapse-with-table collapse' + (collapsedMenuItem === 'paymentMethods' ? ' show': '')}>
								{collapsedMenuItem === 'paymentMethods' && <PaymentMethods accountInfo={accountInfo} />}
							</div>
						</div>
					}

					{canViewPayments &&
						<div className="container-accordion-content container-client-adjustemnts">
							<h3
								onClick={() => this.setCollapsedMenuItem('payments')}
								className={collapsedMenuItem === 'payments' ? '' : 'collapsed'}
								data-toggle="collapse"
							>
								Payments
								{this.props.accountPostPayment && (
									<span className="float-right badge badge-warning">
									${this.props.accountPostPayment.toFixed(2)} PENDING
								</span>
								)}
							</h3>
							<div className={'collapse-with-table collapse' + (collapsedMenuItem === 'payments' ? ' show': '')}>
								{collapsedMenuItem === 'payments' && <Payments accountInfo={accountInfo} />}
							</div>
						</div>
					}
					{canViewRecurringCredits &&
						<div className="container-accordion-content container-client-adjustemnts">
							<h3
								onClick={() => this.setCollapsedMenuItem('reccuringCredits')}
								className={collapsedMenuItem === 'reccuringCredits' ? '' : 'collapsed'}
								data-toggle="collapse"
							>
								Recurring Credits
								{billingBadjesData.activeRecurringCredits > 0 && (
									<span className="float-right badge badge-warning">
									{billingBadjesData.activeRecurringCredits} Approved
								</span>
								)}
							</h3>
							<div className={'collapse-with-table collapse' + (collapsedMenuItem === 'reccuringCredits' ? ' show': '')}>
								{collapsedMenuItem === 'reccuringCredits' && <ReccuringCredits accountInfo={accountInfo} />}
							</div>
						</div>
					}
					{canViewDiscounts &&
						<div className="container-accordion-content container-client-adjustemnts">
							<h3
								onClick={() => this.setCollapsedMenuItem('discounts')}
								className={collapsedMenuItem === 'discounts' ? '' : 'collapsed'}
								data-toggle="collapse"
							>
								Discounts
								{billingBadjesData.activeDiscounts > 0 && (
									<span className="float-right badge badge-warning">
									{billingBadjesData.activeDiscounts} Active
								</span>
								)}
							</h3>
							<div className={'collapse-with-table collapse' + (collapsedMenuItem === 'discounts' ? ' show': '')}>
								{collapsedMenuItem === 'discounts' && <Discounts accountInfo={accountInfo} />}
							</div>
						</div>
					}
					{canViewPaymentPromises &&
						<div className="container-accordion-content container-client-adjustemnts">
							<h3
								onClick={() => this.setCollapsedMenuItem('paymentPromises')}
								className={collapsedMenuItem === 'paymentPromises' ? '' : 'collapsed'}
								data-toggle="collapse"
							>
								Payment Promises
								{billingBadjesData.activePaymentPromises > 0 &&
									<span className="float-right badge badge-warning">
								{billingBadjesData.activePaymentPromises} Active
							</span>
								}
							</h3>
							<div className={'collapse-with-table collapse' + (collapsedMenuItem === 'paymentPromises' ? ' show': '')}>
								{collapsedMenuItem === 'paymentPromises' && <PaymentPromises accountInfo={accountInfo} />}
							</div>
						</div>
					}
					{canViewTaxExemptions &&
						<div className="container-accordion-content container-client-adjustemnts">
							<h3
								onClick={() => this.setCollapsedMenuItem('taxExemptions')}
								className={collapsedMenuItem === 'taxExemptions' ? '' : 'collapsed'}
								data-toggle="collapse"
							>
								Tax Exemptions
								{billingBadjesData.activeTaxExemptions > 0 &&
									<span className="float-right badge badge-warning">
								{billingBadjesData.activeTaxExemptions} Active
							</span>
								}
							</h3>
							<div className={'collapse-with-table collapse' + (collapsedMenuItem === 'taxExemptions' ? ' show': '')}>
								{collapsedMenuItem === 'taxExemptions' && <TaxExemptions accountInfo={accountInfo} />}
							</div>
						</div>
					}
					{canViewHistorical &&
						<div className="container-accordion-content container-client-adjustemnts">
							<h3
								onClick={() => this.setCollapsedMenuItem('statusHistory')}
								className={collapsedMenuItem === 'statusHistory' ? '' : 'collapsed'}
								data-toggle="collapse"
							>
								Historical Changes
							</h3>
							<div className={'collapse-with-table collapse' + (collapsedMenuItem === 'statusHistory' ? ' show': '')}>
								{collapsedMenuItem === 'statusHistory' && <StatusHistory accountInfo={accountInfo} />}
							</div>
						</div>
					}
				</div>
			</div>
		);
	}
}

Billing.propTypes = {
	accountInfo: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
	const billingBadjesData = getAccountDetails(state).billing.billingBadjes,
	myAutoPayInfo = getAccountDetails(state).accountDetails.myAutoPayInfo,
	myDistributionMethods = getAccountDetails(state).billing.distributionMethods,
	primaryContacts = getAdmin(state).primaryContacts,
	accountPostPayment = getAccountDetails(state).billing.balancesInfo.postPaymentAmount,
	canViewOCC = getUserPermission(state, 'BILLING', 'BILLING_OCC_VIEW'),
	canViewInvoices = getUserPermission(state, 'BILLING', 'BILLING_INVOICES_VIEW'),
	canViewPayments = getUserPermission(state, 'BILLING', 'BILLING_PAYMENTS_VIEW'),
	canEditAutopay = getUserPermission(state, "BILLING", "BILLING_EDIT_AUTOPAY"),
	canEditPaperless = getUserPermission(state, "BILLING", "BILLING_EDIT_PAPERLESS"),
	canEditCustomerPortalAccess = getUserPermission(state, "BILLING", "BILLING_EDIT_CUSTOMER_PORTAL_STATUS"),
	canViewBalances = getUserPermission(state, "BILLING", "BILLING_BALANCES_VIEW"),
	canViewInstallmentPlans = getUserPermission(state, "BILLING", "BILLING_INSTALLMENT_PLANS_VEW"),
	canViewRecurringCredits = getUserPermission(state, "BILLING", "BILLING_RECURRING_CREDITS_VIEW"),
	canViewDiscounts = getUserPermission(state, "BILLING", "BILLING_DISCOUNTS_VIEW"),
	canViewPaymentPromises = getUserPermission(state, "BILLING", "BILLING_PAYMENT_PROMISES_VIEW"),
	canViewTaxExemptions = getUserPermission(state, "BILLING", "BILLING_TAX_EXEMPTIONS_VIEW"),
	canViewHistorical = getUserPermission(state, "BILLING", "BILLING_HISTORICAL_CHANGES_VIEW"),
	canPayUnpaidInvoices = getUserPermission(state, "BILLING", "BILLING_PAY_NOW_UNPAID_INVOICES"),
	canPaySpecificInvoices = getUserPermission(state, "BILLING", "BILLING_PAY_NOW_SPECIFIC_INVOICES"),
	canPayCreditToAccount = getUserPermission(state, "BILLING", "BILLING_PAY_NOW_CREDIT_ACCOUNT"),
	canPayDepositPayment = getUserPermission(state, "BILLING", "BILLING_PAY_NOW_DEPOSIT_PAYMENT"),
	canManagePaymentMethods = state.paymentProviders.canManagePaymentMethods && getUserPermission(state, "API", "API_MANAGE_PAYMENT_METHODS"),
	autoPayWarning = getAccountAutoPayStatus(state).autoPayWarningMessage,
	autoPayStatus = getAccountAutoPayStatus(state).accountAutoPayStatus;

	let payNowPermissions =
		[
			{canPayUnpaidInvoices: canPayUnpaidInvoices},
			{canPaySpecificInvoices: canPaySpecificInvoices},
			{canPayCreditToAccount: canPayCreditToAccount},
			{canPayDepositPayment: canPayDepositPayment}
		]


	return {
		billingBadjesData, myAutoPayInfo,
		myDistributionMethods, primaryContacts,
		accountPostPayment,
		// accountBalance,
		canViewOCC, canViewInvoices,
		canViewPayments, canEditAutopay,
		canEditPaperless, canEditCustomerPortalAccess,
		canViewBalances, canViewInstallmentPlans,
		canViewRecurringCredits, canViewDiscounts,
		canViewPaymentPromises, canViewTaxExemptions,
		canViewHistorical, canPayUnpaidInvoices,
		canPaySpecificInvoices, canPayCreditToAccount,
		canPayDepositPayment, payNowPermissions,
		canManagePaymentMethods,
		autoPayWarning,
		autoPayStatus
	};
};

const mapDispatchToProps = {
	getBillingBadjes,
	emptyBillingBadjes,
	getAccountDistributionMethod,
	getMyAutoPayInfo,
	emptyMyAutoPayInfo,
	showModal,
	getAccountTypeDistributionMethods,
	emptyAccountTypeDistributionMethods,
	getPrimaryContacts,
	getCurrentPaymentProviderSupportsPaymentMethodStorage,
	getAccountAutoPay
};

export default connect(mapStateToProps, mapDispatchToProps)(Billing);
